import {
  ChangeDetectionStrategy,
  Component,
  Input,
  NgModule,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
  selector: 'i2l-ui-explore-link',
  template: `
    <ng-container *ngIf="link">
      <ng-container *transloco="let t">
        <a [href]="link" target="_blank"
          ><span [innerHTML]="t('actions.explore')"></span
        ></a>
      </ng-container>
    </ng-container>
  `,
  styleUrls: ['./explore-link.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExploreLinkComponent {
  @Input()
  link!: string;
}

@NgModule({
  imports: [CommonModule, TranslocoModule],
  declarations: [ExploreLinkComponent],
  exports: [ExploreLinkComponent],
})
export class ExploreLinkComponentModule {}
